import React, { useEffect, useState } from "react";
import {
  Stepper,
  Step,
  StepLabel,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  TextField,
  Typography,
  IconButton,
} from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";
import { useDispatch } from "react-redux";
import {
  changeJobApplicationStatus,
  getAllOfferLetter,
  getApplicants,
  getApplicationStatusHistory,
  getInterviewRounds,
  getOfferLetter,
  getOpenJobs,
  getRounds,
  getSingleApplicantById,
  postDocumentRequest,
  postOfferLetter,
  revokeTheoffer,
} from "../../../Redux/Reducers/JobReducer";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import { useSelector } from "react-redux";
import OkModal from "./SideFeedComponents/okModal";
import ConfirmationModal from "./SideFeedComponents/ConfirmationModal";
import TextInputModal from "./SideFeedComponents/TextInputModal";
import InterviewScheduleModal from "./SideFeedComponents/InterviewScheduleModal";
import InterviewScheduleSlider from "./InterviewScheduleSlider";
import InterviewRounds from "./SideFeedComponents/InterviewRounds";
import OfferLetterDrawer from "./SideFeedComponents/OfferLetterDrawer";
import { useNavigate } from "react-router-dom";
import CreateOfferActionModal from "./CreateOfferActionModal";
import DocumentRequestSlider from "./DocumentRequestSlider";
import { mapDocumentPayload } from "../../../Components/Custom/DocumentMapper";
import { toast } from "react-toastify";

const ApplicationTracker = ({ applicant }) => {
  // console.log("applicantNNN", applicant);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [statusModal, setStatusModal] = useState(false);
  const [confirmModal, setConfirmModal] = useState(false);
  const [inputModalTitle, setInputModalTitle] = useState("");
  const [cancelButtonText, setCancelButtonText] = useState("Reject");
  const [buttontextColor, setButtontextColor] = useState("white");
  const [confirmButtonText, setConfirmButtonText] = useState("");
  const [cancelButtonColor, setCancelButtonColor] = useState("#FF6B6B");
  const [visible, setVisible] = useState(false);
  const [inputModal, setInputModal] = useState(false);
  const [title, setTitle] = useState("");
  const [message, setMessage] = useState("");
  const [remarks, setRemarks] = useState("");
  const [nextStatus, setNextStatus] = useState("");
  const [localStatus, setLocalStatus] = useState(applicant?.status);
  const [pendingStatus, setPendingStatus] = useState("");
  // const [history, setHistory] = useState([]);
  const [showInterviewModal, setShowInterviewModal] = useState(false);
  const [showRounds, setShowRounds] = useState(false);
  const [showSchedule, setShowSchedule] = useState(false);
  const history =
    useSelector((state) => state?.jobs?.applicationStatusHistory) || [];
  const [currentApplicationId, setCurrentApplicationId] = useState(
    applicant?.application_id
  );
  // Add useEffect to fetch application history
  const [showOfferDrawer, setShowOfferDrawer] = useState(false);
  const [showOfferActionModal, setShowOfferActionModal] = useState(false);
  const [showDocumentDrawer, setShowDocumentDrawer] = useState(false);
  const [requestedDocuments, setRequestedDocuments] = useState([]);
  const [showRevokeDialog, setShowRevokeDialog] = useState(false);
  const [revocationRemarks, setRevocationRemarks] = useState("");
  const [revokingOffer, setRevokingOffer] = useState(false);
  // console.log("historyNNN", history);

  useEffect(() => {
    if (applicant?.application_id) {
      setCurrentApplicationId(applicant.application_id);
    }
  }, [applicant]);

  useEffect(() => {
    if (applicant?.status) {
      setLocalStatus(applicant.status);
      if (pendingStatus && applicant.status === pendingStatus) {
        setPendingStatus("");
      }
    }
  }, [applicant?.status, pendingStatus]);

  const currentStatus = pendingStatus || localStatus;
  const canOpenDocumentsDrawer = [
    "Offer Accepted",
    "Document Verification",
    "Document Verified",
  ].includes(currentStatus);

  // console.log("currentStatuscurrentStatus", currentStatus,  localStatus);

  useEffect(() => {
    if (applicant?.application_id) {
      dispatch(getInterviewRounds(applicant.application_id));
      dispatch(getOfferLetter(applicant.application_id));
    }
  }, [currentStatus]);

  useEffect(() => {
    dispatch(
      getApplicationStatusHistory({ id: applicant?.application_id })
    ).then((res) => {
      console.log("resoponse", res);
    });
  }, [currentStatus]);

  // console.log('applicatn',applicant)

  const steps = [
    { step: "Shortlist", status: "Shortlisted", done: "Shortlisted" },
    {
      step: "Interview",
      status: "Selected",
      done: "Interviewed",
      intermediateStates: ["Interview In-Progress"],
    },
    {
      step: "Offer",
      status: "Offer Accepted",
      done: "Offer Accepted",
      intermediateStates: ["Offer Released", "Offer Revised"],
    },
    {
      step: "Documents",                          
      status: "Document Verification",             
      done: "Document Verified",               
      intermediateStates: ["Document Rejected"],
    },
    { step: "Join", status: "Joined", done: "Joined" },
  ];

  const getStepIndexForStatus = (status, steps) => {
    for (let i = 0; i < steps.length; i++) {
      const step = steps[i];
      if (
        step.status === status ||
        (step.intermediateStates && step.intermediateStates.includes(status))
      ) {
        return i;
      }
    }
    return -1;
  };

  let beforeRejectStatus = null;
  const beforRejectStatus =
    history.length > 0 &&
      history[1]?.status != "On Hold" &&
      history[1]?.status != "Rejected"
      ? history[1]?.status
      : history[2]?.status;

  const beforRejectStepStatus = history.find(
    (h, index) => index > 0 && steps.some((step) => step.status === h.status)
  )?.status;
  const rejectStepIndex = steps.findIndex(
    (s) => s.done == beforRejectStepStatus
  );
  const rejectStep = steps[rejectStepIndex + 1]?.step;

  console.log("history", history);
  const isStepDone = (stepStatus) => {
    if (history?.length <= 0) return false;
    let stepIndex = allPositiveStatus.indexOf(stepStatus);
    let lastSeenIndex = -1;

    for (let i = 0; i < history.length; i++) {
      if (allPositiveStatus?.includes(history[i]?.status)) {
        lastSeenIndex = allPositiveStatus.indexOf(history[i].status);
        i = history.length;
      }
    }
    if (stepIndex < 0 || lastSeenIndex < 0) return false;
    if (stepIndex <= lastSeenIndex) return true;
    return false;
  };

  const allPositiveStatus = [
    "In Review",
    "Shortlisted",
    "Interview In-Progress",
    "Selected",
    "Offer Released",
    "Offer Revised",
    "Offer Accepted",
    "Document Verification",  
    "Document Verified",      
    "Joined",
  ];

  useEffect(() => {
    for (let i = 1; i < history.length; i++) {
      if (allPositiveStatus.includes(history[i].status)) {
        beforeRejectStatus = history[i].status;
        break;
      }
    }
  }, [history]);

  const generateAIRemark = () => {
    if (nextStatus == "Shortlisted") {
      setRemarks(
        "Congratulations! After reviewing your application, we are pleased to inform you that you have been shortlisted for the next stage of the hiring process. We will be in touch soon with further details."
      );
    } else if (nextStatus == "Rejected") {
      setRemarks(
        "Thank you for your application. After careful review, we’ve decided to move forward with another candidate. We appreciate your time and wish you the best in your job search."
      );
    }
  };

  // console.log('applicant',applicant)

  const changeStatus = async (statusToChange) => {
    const resolvedStatus = statusToChange || nextStatus;
    const payload = {
      application_id: applicant?.application_id,
      // status: 'In Review',
      status: resolvedStatus, // Use passed status or nextStatus
      remarks:
        statusToChange === "Rejected" || statusToChange === "Shortlisted"
          ? remarks
          : "",
    };

    try {
      const statusResponse = await dispatch(
        changeJobApplicationStatus(payload)
      ).unwrap();

      if (statusResponse) {
        setLocalStatus(resolvedStatus);
        setPendingStatus(resolvedStatus);

        // Clear modals
        setConfirmModal(false);
        setInputModal(false);
        setRemarks("");

        // Fetch updated data
        await Promise.all([
          dispatch(getApplicants({ job_id: applicant?.job_id })),
          dispatch(
            getApplicationStatusHistory({ id: applicant?.application_id })
          ),
        ]);
      }
    } catch (error) {
      console.error("Error updating status:", error);
    }
  };

  const onCancle = () => {
    setConfirmModal(false);

    switch (cancelButtonText) {
      case "Cancel":
        setConfirmModal(false);
        setInputModal(false);
        break;

      case "Reject":
        setRemarks("");
        setInputModalTitle("Confirm Rejection!");
        setMessage(
          "Are you sure you want to reject this applicant? Please provide a reason for the rejection."
        );
        setConfirmButtonText("Reject");
        setCancelButtonText("Cancel");
        setButtontextColor("white");
        setCancelButtonColor("#FFFFFF1A");
        setNextStatus("Rejected");
        setInputModal(true);
        break;

      case "View Offer":
        // changeStatus();
        dispatch(getAllOfferLetter(applicant?.application_id))
          .then(() => {
            // Then navigate using the correct path
            navigate(
              `/view-recruiter-offer-letter/${applicant?.application_id}`,
              {
                state: { applicant },
              }
            );
          })
          .catch((err) => {
            console.error("Error fetching offer letter:", err);
          });
        setConfirmModal(false);

        break;

      case "Not Joined":
        changeStatus("Not Joined");
        break;

      default:
        setConfirmModal(false);
        break;
    }
  };

  const handleConfirmRevokeOffer = async () => {
    if (!applicant?.application_id || !revocationRemarks.trim()) {
      return;
    }

    try {
      setRevokingOffer(true);
      await dispatch(
        revokeTheoffer({
          application_id: applicant.application_id,
          remarks: revocationRemarks.trim(),
        })
      ).unwrap();

      await Promise.all([
        dispatch(getApplicants({ job_id: applicant?.job_id })),
        dispatch(getApplicationStatusHistory({ id: applicant?.application_id })),
        dispatch(getSingleApplicantById(applicant?.application_id)),
      ]);

      setShowRevokeDialog(false);
      setRevocationRemarks("");
    } catch (error) {
      console.error("Error revoking offer:", error);
    } finally {
      setRevokingOffer(false);
    }
  };

  const handleOpenRevokeDialog = () => {
    setConfirmModal(false);
    setShowRevokeDialog(true);
  };

  const onConfirm = async () => {
    try {
      setConfirmModal(false);

      switch (confirmButtonText) {
        case "Proceed again":
          await changeStatus(beforRejectStatus || "In Review");
          break;

        case "Shortlist":
          setInputModal(false);
          // setNextStatus("Shortlisted");
          await changeStatus("Shortlisted");

          break;

        case "Schedule Interview":
          // setNextStatus("Interview In-Progress");
          // setShowInterviewModal(true);
          setShowRounds(true);
          await changeStatus("Interview In-Progress");

          break;

        case "Check Interview Details":
          await changeStatus("Selected");
          break;

        case "Send Offer":
        case "Resend Offer":
          setConfirmModal(false);
          setShowOfferDrawer(true); // Open the offer drawer for resending
          // setShowOfferActionModal(true);
          break;

        case "Joined":
          // setNextStatus("Joined");
          await changeStatus("Joined");
          break;

        case "Reject":
          // setNextStatus("Rejected");
          await changeStatus("Rejected");
          break;

        default:
          setConfirmModal(false);
          break;
      }
    } catch (error) {
      console.error("Error in onConfirm:", error);
    }
  };

  const handleScheduleInterview = async (interviewData) => {
    try {
      if (!interviewData) {
        console.error("Interview data is required");
        return;
      }

      // Change status to Interview In-Progress with interview data
      await changeStatus("Interview In-Progress");

      // Close the interview modal
      setShowInterviewModal(false);

      // Update the UI immediately
      setLocalStatus("Interview In-Progress");

      // Refresh the data
      await Promise.all([
        dispatch(getApplicants({ job_id: applicant?.job_id })),
        dispatch(
          getApplicationStatusHistory({ id: applicant?.application_id })
        ),
      ]);
    } catch (error) {
      console.error("Error scheduling interview:", error);
    }
  };

  // Add this helper function
  const getProgressWidth = (steps, currentStatus, history) => {
    if (currentStatus === "Rejected") {
      const lastCompletedIndex =
        steps.findIndex((s) => s.step === rejectStep) - 1;
      return ((lastCompletedIndex + 1) / steps.length) * 100;
    }

    let currentStepIndex = getStepIndexForStatus(currentStatus, steps);

    if (currentStepIndex === -1) {
      if (currentStatus === "In Review") {
        return 0;
      }
      let highestStepIndex = -1;
      history.forEach((h) => {
        const stepIndex = getStepIndexForStatus(h.status, steps);
        if (stepIndex > highestStepIndex) {
          highestStepIndex = stepIndex;
        }
      });
      currentStepIndex = highestStepIndex;
    }

    currentStepIndex = Math.max(currentStepIndex, -1);

    if (currentStepIndex === -1) {
      return 0;
    } else {
      return ((currentStepIndex + 1) / steps.length) * 100;
    }
  };

  const onStatusClick = (step, stepStatus) => {
    const index = steps.findIndex((s) => s.status == stepStatus);
    if (currentStatus === "Offer Declined" && step === "Offer") {
      // Get the second-to-last status (assuming history is ordered newest-last)
      const prevStatusIndex = history.length >= 2 ? history.length - 2 : -1;
      const previousStatus =
        prevStatusIndex >= 0 ? history[prevStatusIndex]?.status : null;

      // console.log("Previous Status:", previousStatus); // Debug log

      if (previousStatus === "Selected") {
        setShowOfferDrawer(true);
        // setShowOfferActionModal(true);
      } else if (previousStatus === "Offer Revised") {
        setTitle("Offer Revised");
        setMessage(
          "This offer has been revised after being declined and cannot be resent."
        );
        setVisible(true);
      }
      return;
    }
    if (currentStatus == "Rejected") {
      setTitle("Application Rejected!");
      setMessage(
        `The application is rejected by you after ${beforRejectStatus ? beforRejectStatus : "In Review"
        }. If you want to proceed it again then click on proceed.`
      );
      setConfirmButtonText("Proceed again");
      setCancelButtonText("Cancel");
      setCancelButtonColor("#FFFFFF1A");
      setNextStatus(beforRejectStatus ? beforRejectStatus : "In Review");
      setConfirmModal(true);
      return;
    }

    if (currentStatus === "Offer Revised" && step === "Offer") {
      dispatch(getAllOfferLetter(applicant?.application_id))
        .then(() => {
          navigate(`/view-recruiter-offer-letter/${applicant?.application_id}`);
        })
        .catch((err) => {
          console.error("Error fetching offer letter:", err);
        });
      return;
    }

    if (currentStatus == "Joined") {
      setTitle("Canidate Joined!");
      setMessage(
        `All steps are completed successfully. And candidate joined the company.`
      );
      setVisible(true);
      return;
    }
    if (isStepDone(stepStatus && stepStatus !== "Document Verification")) {
      // console.log("stepStatusMMMM", stepStatus)
      //  setShowDocumentDrawer(true);
      setTitle("Step Complited!");
      setMessage(
        `This step is completed successfully. Proceed for next steps.`
      );
      setVisible(true);
      return;
    }
    // if(isStepDone(stepStatus == "Document Verification")){
    if(stepStatus == "Document Verification" && canOpenDocumentsDrawer){
      setShowDocumentDrawer(true);
      return;
    }

    if (
      (!isStepDone(stepStatus) &&
        history?.some((h) => h?.status == steps[index - 1]?.status)) ||
      currentStatus == "In Review" ||
      history?.length == 0 ||
      step == "Shortlist"
    ) {
      if (!isStepDone(stepStatus) && step == "Shortlist") {
        setRemarks("");
        setInputModalTitle("Shortlist!");
        setMessage(
          "You want to shortlist this application? Please provide an reason for the shortlisting."
        );
        setConfirmButtonText("Shortlist");
        setCancelButtonText("Reject");
        // setCancelButtonColor("#FF6B6B");
        setNextStatus("Shortlisted");
        setInputModal(true);
      }
      if (currentStatus == "Shortlisted" && step == "Interview") {
        // setTitle("Schedule Interview");
        // setShowInterviewModal(true)
        dispatch(getOpenJobs());
        setShowRounds(true);
        setConfirmModal(false);
        setMessage(
          `The candidate has been shortlisted. Please schedule the interview.`
        );
        setConfirmButtonText("Schedule Interview");
        setCancelButtonText("Reject");
        setCancelButtonColor("#FF6B6B");
      }
      if (currentStatus == "Interview In-Progress" && step == "Interview") {
        setShowRounds(true);
        setTitle("Interview In-Progress");
        setMessage(
          `The candidate interview has been scheduled. After Interview result it will automatically update.`
        );
        // setConfirmButtonText("Check Interview Details");

        setCancelButtonText("Reject");
        setCancelButtonColor("#FF6B6B");
        // setConfirmModal(true);
      } else if (currentStatus == "Selected" && step == "Offer") {
        // setTitle("Send Offer Letter!");
        // setMessage(
        //   `The candidate has selected on interview. Send the offer letter.`
        // );
        // setConfirmButtonText("Send Offer");
        // setCancelButtonText("Reject");
        // setCancelButtonColor("#FF6B6B");
        // setNextStatus("Offer Released");
        // setConfirmModal(true);
        setShowOfferDrawer(true);
        // setShowOfferActionModal(true);/
      } else if (
        currentStatus === "Offer Released" ||
        (currentStatus === "Offer Re-released" && step == "Offer")
      ) {
        setTitle("Offer Sent!");
        setMessage(
          `The offer letter has been successfully ${currentStatus == "Offer Released"
            ? "sent"
            : currentStatus == "Offer Re-released"
              ? "resent"
              : "sent"
          } to the candidate. If you need to resend it or withdraw the offer, please choose an option below.`
        );
        setConfirmButtonText("Resend Offer");
        setCancelButtonText("View Offer");
        setCancelButtonColor("#FFFFFF1A");
        setNextStatus("Offer Re-released");
        setConfirmModal(true);
      }

      // else if (currentStatus === "Offer Accepted" && step == "Join") {
      //   setTitle("Offer Accepted!");
      //   setMessage(
      //     "The candidate has accepted the offer. Please mark as joined."
      //   );
      //   setConfirmButtonText("Joined");
      //   setCancelButtonText("Not Joined");
      //   setCancelButtonColor("#FFFFFF1A");
      //   setNextStatus("Joined");
      //   setConfirmModal(true);
      // }

      else if (currentStatus === "Document Verified" && step == "Join") {
        setTitle("Document Verified!");
        setMessage(
          "The candidate Documents are Verified. Please mark as joined."
        );
        setConfirmButtonText("Joined");
        setCancelButtonText("Not Joined");
        setButtontextColor("white");
        setCancelButtonColor("#FF6B6B");
        setNextStatus("Joined");
        setConfirmModal(true);
      } else if (currentStatus === "Offer Accepted" && step === "Documents") {
        setShowDocumentDrawer(true);
        return;
      } else if (currentStatus === "Document Verification" && step === "Documents") {
        setTitle("Documents Already Requested!");
        setMessage(
          `Document request has already been sent to the candidate. Proceed to mark the candidate as joined once documents are verified.`
        );
        setVisible(true);
        return;
      }

      else if (currentStatus === "Not Joined" && step == "Join" ) {
        setTitle("Candidate Not Joined!");
        setMessage(
          "The candidate has not joined for some reason. Do you want to proceed with joining them again?"
        );
        setConfirmButtonText("Joined");
        setCancelButtonText("Cancel");
        setButtontextColor("white");
        setCancelButtonColor("#FF6B6B");
        setNextStatus("Not Joined");
        setConfirmModal(true);
      } else if (
        currentStatus == "Offer Revoked" ||
        (currentStatus == "Offer Cancelled" && step == "Offer")
      ) {
        setTitle("Offer withdrew!");
        setMessage(
          `The offer has been ${currentStatus == "Offer Revoked" ? "" : "Cancelled"
          } successfully. If you need to resend the offer, please choose an option below.`
        );
        setConfirmButtonText("Resend Offer");
        setCancelButtonText("Cancel");
        setCancelButtonColor("#FFFFFF1A");
        setNextStatus("Offer Re-released");
        setConfirmModal(true);
      }
    } else {
      setTitle("Step Pending!");
      setMessage(
        `This step is pending. You need to complete previous steps first.`
      );
      setVisible(true);
    }
  };

  const isStepAllowed = (step, currentStatus) => {
    switch (step) {
      case "Shortlist":
        return currentStatus === "In Review";
      case "Interview":
        return currentStatus === "Shortlisted";
      case "Offer":
        return currentStatus === "Selected";
      case "Join":
        return currentStatus === "Offer Accepted";
      default:
        return false;
    }
  };

  const handleScheduleClick = (roundId) => {
    setShowRounds(false); // Close rounds
    setShowSchedule(true); // Open schedule
  };



  const getStep = (step) => {
    const stepIndex = steps.findIndex((item) => item.step === step.step);
    const currentStepDone = isStepDone(step.status);

    // Handle rejected state
    if (currentStatus === "Offer Declined") {
      if (step.step === "Offer") {
        return {
          color: "#FF6B6B",
          icon: "cancel",
          text: "Offer Declined",
          isDone: false,
        };
      }
      // Show completed steps before decline
      if (stepIndex < steps.findIndex((s) => s.step === "Offer")) {
        return {
          color: "#00E9E7",
          icon: "checkmark",
          text: step.done,
          isDone: true,
        };
      }
    }

    if (currentStatus === "Rejected") {
      if (step.step === rejectStep) {
        return {
          color: "#FF6B6B",
          icon: "cancel",
          text: "Rejected",
          isDone: false,
        };
      }
      // Show completed steps before rejection
      if (stepIndex <= rejectStepIndex) {
        return {
          color: "#00E9E7",
          icon: "checkmark",
          text: step.done,
          isDone: true,
        };
      }
    }
    if (step.step === "Offer") {
      switch (currentStatus) {
        case "Offer Released":
          return {
            color: "#00E9E7",
            icon: "circle",
            text: "Offer Released",
            isDone: true,
          };
        case "Offer Revised":
          return {
            color: "#00E9E7",
            icon: "circle",
            text: "Offer Revised",
            isDone: true,
            clickable: true,
          };
        case "Offer Accepted":
          return {
            color: "#00E9E7",
            icon: "checkmark",
            text: "Offer Accepted",
            isDone: true,
          };
        case "Offer Revoked":
          return {
            color: "#FF6B6B",
            icon: "cancel",
            text: "Offer Revoked",
            isDone: true,
          };
      }
    }

    // Handle Interview In-Progress
    if (step.step === "Interview") {
      if (currentStatus === "Interview In-Progress") {
        return {
          color: "#00E9E7", // Orange color for in-progress
          icon: "circle",
          text: "Interview In-Progress",
          isDone: false,
        };
      }
      if (currentStatus === "Selected" || isStepDone("Selected")) {
        return {
          color: "#00E9E7",
          icon: "checkmark",
          text: "Interviewed",
          isDone: true,
        };
      }
    }

    if (step.step === "Documents") {
      if (
        currentStatus === "Document Verification" ||
        currentStatus === "Document Rejected"
      ) {
        return {
          color: "#00E9E7",
          icon: "circle",
          text: "Docs Requested",
          isDone: false,
        };
      }
      if (isStepDone("Document Verified")) {
        return {
          color: "#00E9E7",
          icon: "checkmark",
          text: "Document Verified",
          isDone: true,
        };
      }
    }

    if (step.step === "Join") {
      if (currentStatus === "Joined") {
        return {
          color: "#00E9E7",
          icon: "checkmark",
          text: "Joined",
          isDone: true,
        };
      }
      if (currentStatus === "Not Joined") {
        return {
          color: "#FF6B6B",
          icon: "cancel",
          text: "Not Joined",
          isDone: false,
        };
      }
    }

    // Handle completed steps
    if (currentStepDone) {
      return {
        color: "#00E9E7",
        icon: "checkmark",
        text: step.done,
        isDone: true,
      };
    }

    // Default state
    return {
      color: "gray",
      icon: "circle",
      text: step.step,
      isDone: false,
    };
  };

  const handleOfferSubmit = async (formData) => {
    try {
      const response = await dispatch(postOfferLetter(formData)).unwrap();

      if (response) {
        // Close the drawer
        setShowOfferDrawer(false);

        // Only update status if API returns a new status
        if (response?.data?.status) {
          setLocalStatus(response.data.status);

          // Update applicant status if needed
          if (applicant) {
            applicant.status = response.data.status;
          }

          // Refresh application history to get latest status
          await dispatch(
            getApplicationStatusHistory({ id: applicant?.application_id })
          );
        }
      }
    } catch (error) {
      console.error("Error sending offer:", error);
    }
  };

  const handleInterviewStatusUpdate = (newStatus) => {
    setLocalStatus(newStatus); // ✅ force the stepper to re-render
  };

  // Add this new function to handle the modal actions
  const handleOfferAction = (action) => {
    setShowOfferActionModal(false);

    if (action === 'attach') {
      // Attach manually - open the offer drawer
      setShowOfferDrawer(true);
    } else if (action === 'createLater') {
      // Create offer later - navigate to your component
      // Replace '/create-offer-later' with your actual route
      navigate('/compose-letter', {
        state: { applicant, applicationId: applicant?.application_id }
      });
    }
  };


  const mapDocumentPayload = (doc) => {
  // Define category mapping based on document name
  const getCategory = (docName) => {
    const identityDocs = ["Aadhaar Card", "PAN Card", "Passport", "Voter ID", "Driving License"];
    const educationDocs = ["10th Marksheet", "12th Marksheet", "Graduation Degree", "Post Graduation Degree", "Diploma Certificate", "Other Certifications"];
    const employmentDocs = ["Previous Offer Letter", "Last 3 Months Salary Slips", "Experience Letter", "Relieving Letter", "Bank Statement (3 months)", "Form 16"];
    const addressDocs = ["Electricity Bill", "Rent Agreement", "Bank Passbook", "Gas Bill"];
    
    if (identityDocs.includes(docName)) return "Personal";
    if (educationDocs.includes(docName)) return "Education";
    if (employmentDocs.includes(docName)) return "Professional";
    if (addressDocs.includes(docName)) return "Address";
    return "Others";
  };

  // Define allowed file types based on document type
  const getAllowedFileTypes = (docName) => {
    // Professional/Employment documents usually accept PDF
    const employmentDocs = ["Previous Offer Letter", "Last 3 Months Salary Slips", "Experience Letter", "Relieving Letter", "Bank Statement (3 months)", "Form 16"];
    if (employmentDocs.includes(docName)) {
      return ["image/png", "image/jpeg", "application/pdf"];
    }
    // Default for identity and other docs
    return ["image/png", "image/jpeg"];
  };

  // Define remarks based on document
  const getRemarks = (docName) => {
    const remarksMap = {
      "Aadhaar Card": "Government-issued ID proof",
      "PAN Card": "Tax identification document",
      "Passport": "International travel document",
      "Voter ID": "Election identification",
      "Driving License": "Driving authorization",
      "Experience Letter": "Previous employment proof",
      "Relieving Letter": "Employment separation document",
      "Form 16": "Tax deduction certificate",
      // Add more as needed
    };
    return remarksMap[docName] || `Please upload ${docName}`;
  };

  return {
    file_name: doc.file_name || doc, // Handle both string and object input
    allowed_file_types: doc.allowed_file_types || getAllowedFileTypes(doc.file_name || doc),
    category: doc.category || getCategory(doc.file_name || doc),
    remarks: doc.remarks || getRemarks(doc.file_name || doc),
    is_mandatory: doc.is_mandatory || false
  };
};


  const handleDocumentRequestSubmit = async (documents) => {
    setRequestedDocuments(documents);

    const documentRequests = documents.map((doc) => mapDocumentPayload(doc));
    const requestPayload = {
      application_id: applicant.application_id,
      documents: documentRequests,
    };

    // Update application status to "Document Verification"
    const statusPayload = {
      application_id: applicant.application_id,
      status: "Document Verification",
      remarks: `Requested documents: ${documents.join(", ")}`,
    };
// console.log("requestPayload52525", requestPayload)
    try {
      // 1. Post document requirements
      await dispatch(postDocumentRequest(requestPayload)).unwrap();

      // 2. Change application status to "Document Verification"
      try {
        await dispatch(changeJobApplicationStatus(statusPayload)).unwrap();
        setLocalStatus("Document Verification");
      } catch (statusError) {
        console.warn("Backend does not support 'Document Verification' status update:", statusError);
      }

      await Promise.all([
        dispatch(getApplicants({ job_id: applicant?.job_id })),
        dispatch(getApplicationStatusHistory({ id: applicant?.application_id })),
        dispatch(getSingleApplicantById(applicant?.application_id)),
      ]);
      toast.success("Document request sent successfully!");
      setShowDocumentDrawer(false);
    } catch (error) {
      console.error("Error updating document request status:", error);
      toast.error(error?.message || "Failed to send document request.");
    }
  };

  return (
    <>
      <Box
        sx={{
          position: "relative",
          width: "100%",
          padding: "20px",
        }}
      >
        {/* Horizontal line connecting steps */}
        <Box
          sx={{
            position: "absolute",
            top: "35%",
            left: "15%",
            width: "68%",
            height: "2px",
            background: `linear-gradient(to right, #00E9E7 ${getProgressWidth(steps, currentStatus, history)}%, 
          rgba(128, 128, 128, 0.5) ${getProgressWidth(steps, currentStatus, history)}%)`,
            zIndex: 0,
          }}
        />

        {/* Stepper container */}
        <Box
          display="flex"
          flexDirection="row"
          justifyContent="space-around"
          width="100%"
        >
          {steps?.map((item, index) => {
            const stepState = getStep(item);

            return (
              <Box
                key={index}
                display="flex"
                flexDirection="column"
                alignItems="center"
                sx={{ flex: 1 }}
              >
                <IconButton
                  onClick={() => {
                    const stepState = getStep(item);
                    if (
                      currentStatus === "Offer Revised" &&
                      item.step === "Offer"
                    ) {
                      dispatch(getAllOfferLetter(applicant?.application_id))
                        .then(() => {
                          navigate(
                            `/view-recruiter-offer-letter/${applicant?.application_id}`,
                            {
                              state: { applicant },
                            }
                          );
                        })
                        .catch((err) => {
                          console.error("Error fetching offer letter:", err);
                        });
                    } else {
                      onStatusClick(item.step, item.status);
                    }
                  }}
                  sx={{
                    bgcolor: stepState.color,
                    borderColor: stepState.color,
                    width: 40,
                    height: 40,
                    mb: 1,
                    cursor:
                      (currentStatus === "Offer Revised" ||
                        currentStatus === "Offer Declined") &&
                        item.step === "Offer"
                        ? "pointer"
                        : "default",
                  }}
                >
                  {stepState.icon === "cancel" ? (
                    <CancelIcon sx={{ color: "white" }} />
                  ) : stepState.icon === "checkmark" ? (
                    <CheckCircleIcon sx={{ color: "white" }} />
                  ) : (
                    <RadioButtonUncheckedIcon
                      sx={{
                        color: "white",
                        width: 24,
                        height: 24,
                      }}
                    />
                  )}
                </IconButton>

                <Typography
                  sx={{
                    fontSize: 12,
                    fontWeight: "bold",
                    color: stepState.color,
                    textAlign: "center",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {stepState.text}
                </Typography>
              </Box>
            );
          })}
        </Box>
      </Box>

      <CreateOfferActionModal
        open={showOfferActionModal}
        onClose={() => setShowOfferActionModal(false)}
        onAction={handleOfferAction}
      />

      <OkModal
        visible={visible}
        title={title}
        message={message}
        onOkPress={() => setVisible(false)}
      />

      <ConfirmationModal
        visible={confirmModal}
        title={title}
        message={message}
        buttontextColor={buttontextColor}
        confirmButtonText={confirmButtonText}
        cancelButtonText={cancelButtonText}
        secondaryButtonText={title === "Offer Sent!" ? "Revoke Offer" : ""}
        cancelButtonColor={cancelButtonColor}
        onClosePress={() => setConfirmModal(false)}
        onCancelPress={onCancle}
        onSecondaryPress={handleOpenRevokeDialog}
        onConfirmPress={onConfirm}
      />

      <TextInputModal
        visible={inputModal}
        title={inputModalTitle}
        message={message}
        placeholder="Reason"
        confirmButtonText={confirmButtonText}
        confirmButtonColor={
          confirmButtonText === "Reject" ? "#FF6B6B" : "#0044C6"
        }
        cancelButtonText={cancelButtonText}
        confirmButtonTextColor={
          confirmButtonText == "Reject" ? "white" : "white"
        }
        cancelButtonColor={cancelButtonColor}
        inputText={remarks}
        setInputText={setRemarks}
        onConfirmPress={onConfirm}
        onCancelPress={onCancle}
        onClosePress={() => setInputModal(false)}
        generateAIRemark={generateAIRemark}
      />

      {/* <InterviewScheduleModal
        open={showInterviewModal}
        onClose={() => setShowInterviewModal(false)}
        onSubmit={handleScheduleInterview}
        candidateId={applicant?.application_id}
      /> */}

      <InterviewRounds
        open={showRounds}
        onClose={() => {
          setShowRounds(false);
          setShowSchedule(false);
        }}
        applicant={applicant}
        candidateId={currentApplicationId}
        onSchedule={handleScheduleClick}
        onStatusUpdate={handleInterviewStatusUpdate}
      />

      {/* <InterviewRoundsList
    open={showRounds}
    onClose={() => {
      setShowRounds(false);
      setShowSchedule(false);
    }}
    candidateId={currentApplicationId}
    onSchedule={handleScheduleClick} 
  /> */}

      {showSchedule && (
        <InterviewScheduleSlider
          open={showSchedule}
          onClose={() => {
            setShowSchedule(false);
            setShowRounds(true); // Return to rounds when closing schedule
          }}
          onSubmit={handleScheduleInterview}
          candidateId={currentApplicationId}
        // applicant={applicant}
        />
      )}

      <OfferLetterDrawer
        open={showOfferDrawer}
        onClose={() => setShowOfferDrawer(false)}
        onSubmit={handleOfferSubmit}
        applicant={applicant}
      />

      <DocumentRequestSlider
        open={showDocumentDrawer}
        onClose={() => setShowDocumentDrawer(false)}
        onSubmit={handleDocumentRequestSubmit}
        applicant={applicant}
      />

      <Dialog
        open={showRevokeDialog}
        onClose={() => {
          setShowRevokeDialog(false);
          setRevocationRemarks("");
        }}
      >
        <DialogTitle>Revoke Offer</DialogTitle>
        <DialogContent>
          <Typography sx={{ mb: 2 }}>
            Please share a reason before revoking this offer.
          </Typography>
          <TextField
            fullWidth
            multiline
            minRows={3}
            label="Revocation Remarks"
            value={revocationRemarks}
            onChange={(e) => setRevocationRemarks(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setShowRevokeDialog(false);
              setRevocationRemarks("");
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleConfirmRevokeOffer}
            color="error"
            variant="contained"
            disabled={revokingOffer || !revocationRemarks.trim()}
          >
            {revokingOffer ? "Revoking..." : "Revoke"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ApplicationTracker;
